import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import RouteWithLayout from './components/RouteWithLayout';
import MinimalNoTopbarLayout from './layouts/MinimalNoTopbar';
import RecoveryPasswordView from './views/RecoveryPassword';
import SignInView from './views/SignIn';

const PublicRoutes = () => (
  <Switch>
    <RouteWithLayout
      component={SignInView}
      exact
      layout={MinimalNoTopbarLayout}
      path='/sign-in'
    />
    <RouteWithLayout
      component={RecoveryPasswordView}
      exact
      layout={MinimalNoTopbarLayout}
      path='/recovery-password'
    />
    <Redirect to='/sign-in' />
  </Switch>
);

export default PublicRoutes;
